// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   UNIVERSAL DESIGN SYSTEM - Glassmorphism Theme
   ============================================ */

/* ============ CSS CUSTOM PROPERTIES ============ */
/* Dark Theme (Default) */
:root,
[data-theme="dark"] {
  /* Primary Colors - Light Gray Theme */
  --primary-color: #cbd5e1;
  --primary-dark: #94a3b8;
  --primary-light: #e2e8f0;

  /* Accent Colors - Very Light Grays */
  --secondary-color: #e2e8f0;
  --accent-color: #f1f5f9;

  /* Backgrounds */
  --dark-bg: #0f172a;
  --light-bg: #f8fafc;
  --body-bg: #0a1628;
  --card-bg: rgba(15, 23, 42, 0.6);
  --glass-bg: rgba(15, 23, 42, 0.7);

  /* Text Colors */
  --white: #ffffff;
  --text-primary: rgba(241, 245, 249, 0.95);
  --text-secondary: rgba(226, 232, 240, 0.75);
  --text-dark: #1e293b;
  --text-light: #64748b;

  /* Borders */
  --border-color: rgba(255, 255, 255, 0.08);
  --border-hover: rgba(226, 232, 240, 0.4);

  /* Spacing */
  --section-padding: clamp(4rem, 8vw, 7rem);
  --card-gap: 1.5rem;
}

/* Light Theme */
[data-theme="light"] {
  /* Primary Colors */
  --primary-color: #64748b;
  --primary-dark: #475569;
  --primary-light: #94a3b8;

  /* Accent Colors */
  --secondary-color: #94a3b8;
  --accent-color: #cbd5e1;

  /* Backgrounds */
  --dark-bg: #0f172a;
  --light-bg: #f8fafc;
  --body-bg: #f1f5f9;
  --card-bg: rgba(255, 255, 255, 0.9);
  --glass-bg: rgba(255, 255, 255, 0.8);

  /* Text Colors */
  --white: #ffffff;
  --text-primary: #1e293b;
  --text-secondary: #475569;
  --text-dark: #0f172a;
  --text-light: #64748b;

  /* Borders */
  --border-color: rgba(15, 23, 42, 0.1);
  --border-hover: rgba(100, 116, 139, 0.3);

  /* Spacing */
  --section-padding: clamp(4rem, 8vw, 7rem);
  --card-gap: 1.5rem;
}

/* ============ GLOBAL RESETS & BASE STYLES ============ */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--body-bg);
  color: var(--text-primary);
  line-height: 1.8;
  font-weight: 400;
  min-height: 100vh;
  overflow-x: hidden;
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Dark theme background gradients */
[data-theme="dark"] body {
  background:
    radial-gradient(circle at 10% 20%, rgba(226, 232, 240, 0.15), transparent 50%),
    radial-gradient(circle at 90% 10%, rgba(241, 245, 249, 0.12), transparent 45%),
    radial-gradient(circle at 50% 80%, rgba(203, 213, 225, 0.1), transparent 50%),
    var(--body-bg);
  background-attachment: fixed;
}

/* Light theme background gradients */
[data-theme="light"] body {
  background:
    radial-gradient(circle at 10% 20%, rgba(100, 116, 139, 0.08), transparent 50%),
    radial-gradient(circle at 90% 10%, rgba(148, 163, 184, 0.06), transparent 45%),
    radial-gradient(circle at 50% 80%, rgba(203, 213, 225, 0.05), transparent 50%),
    var(--body-bg);
  background-attachment: fixed;
}

/* ============ TYPOGRAPHY ============ */
h1 {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  line-height: 1.2;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

[data-theme="dark"] h1 {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="light"] h1 {
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

h2 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

h3 {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.75rem;
}

h4 {
  font-size: clamp(1.25rem, 2.5vw, 1.75rem);
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

p {
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 1rem;
}

a {
  color: var(--primary-light);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--primary-color);
}

/* ============ LAYOUT PATTERNS ============ */
.section {
  position: relative;
  padding: var(--section-padding) 0;
  isolation: isolate;
}

.section::after {
  content: '';
  position: absolute;
  inset: 1rem;
  border-radius: 32px;
  background: radial-gradient(circle at top, rgba(226, 232, 240, 0.1), transparent 55%);
  z-index: -2;
  pointer-events: none;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* ============ GLASSMORPHISM COMPONENTS ============ */
.glass-panel {
  border-radius: 24px;
  padding: 2rem;
  background: var(--glass-bg);
  border: 1px solid var(--border-color);
  box-shadow: 0 20px 80px rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  transition: all 0.45s ease;
}

.glass-panel:hover {
  border-color: rgba(226, 232, 240, 0.4);
  transform: translateY(-4px);
}

.card {
  padding: 1.5rem;
  border-radius: 22px;
  border: 1px solid var(--border-color);
  background: var(--card-bg);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: transform 0.45s ease, border-color 0.45s ease, box-shadow 0.45s ease;
}

.card:hover {
  transform: translateY(-6px);
  border-color: rgba(226, 232, 240, 0.5);
  box-shadow: 0 20px 60px rgba(203, 213, 225, 0.2);
}

/* ============ PILLS & CHIPS ============ */
.pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border-radius: 999px;
  padding: 0.35rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  background: var(--card-bg);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.pill:hover {
  background: rgba(226, 232, 240, 0.15);
  border-color: rgba(226, 232, 240, 0.35);
}

/* ============ EYEBROW LABELS ============ */
.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  font-size: 0.75rem;
  color: var(--primary-light);
  background: rgba(226, 232, 240, 0.12);
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  font-weight: 600;
  margin-bottom: 1rem;
}

/* ============ BUTTONS ============ */
.btn-primary {
  border-radius: 999px;
  padding: 0.85rem 1.8rem;
  border: none;
  font-weight: 600;
  background: linear-gradient(120deg, #cbd5e1, #94a3b8);
  box-shadow: 0 20px 45px rgba(148, 163, 184, 0.3);
  color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 1rem;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 25px 55px rgba(203, 213, 225, 0.4);
}

.btn-secondary {
  border-radius: 999px;
  padding: 0.85rem 1.8rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-weight: 600;
  background: rgba(255, 255, 255, 0.05);
  color: var(--white);
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 1rem;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--primary-light);
}

/* ============ STAT CARDS ============ */
.stat-card {
  padding: 1.35rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
}

.stat-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(226, 232, 240, 0.4);
}

.stat-card strong {
  display: block;
  font-size: 1.8rem;
  color: var(--text-primary);
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.stat-card span {
  color: var(--text-secondary);
  font-size: 0.95rem;
}

/* ============ GRID SYSTEMS ============ */
.grid {
  display: grid;
  gap: var(--card-gap);
}

.grid-auto {
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
}

.grid-stats {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.grid-pills {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

/* ============ FORMS ============ */
.form-control {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 12px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  transition: all 0.3s ease;
  width: 100%;
}

.form-control:focus {
  border-color: var(--primary-light);
  box-shadow: 0 0 0 3px var(--border-hover);
  outline: none;
  background: var(--glass-bg);
}

.form-control::placeholder {
  color: var(--text-light);
  opacity: 0.6;
}

.form-label {
  color: var(--text-primary);
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

/* ============ ATMOSPHERIC EFFECTS ============ */
.aurora {
  position: absolute;
  width: min(45vw, 520px);
  height: min(45vw, 520px);
  border-radius: 55%;
  filter: blur(120px);
  opacity: 0.35;
  mix-blend-mode: screen;
  animation: auroraPulse 22s ease-in-out infinite;
  pointer-events: none;
  z-index: -1;
}

.aurora-pink {
  background: radial-gradient(circle, rgba(241, 245, 249, 0.3), transparent 65%);
  top: -10%;
  right: -10%;
}

.aurora-blue {
  background: radial-gradient(circle, rgba(226, 232, 240, 0.28), transparent 65%);
  bottom: -10%;
  left: -10%;
  animation-delay: -11s;
}

.aurora-cyan {
  background: radial-gradient(circle, rgba(248, 250, 252, 0.25), transparent 65%);
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: -5s;
}

@keyframes auroraPulse {
  0%, 100% {
    transform: scale(0.85) translate3d(0, 0, 0);
    opacity: 0.25;
  }
  50% {
    transform: scale(1.05) translate3d(-10px, 10px, 0);
    opacity: 0.45;
  }
}

/* ============ GRID OVERLAY PATTERN ============ */
.grid-overlay {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(135deg, rgba(226, 232, 240, 0.12), transparent),
    repeating-linear-gradient(0deg, rgba(241, 245, 249, 0.1) 0, rgba(241, 245, 249, 0.1) 1px, transparent 1px, transparent 80px),
    repeating-linear-gradient(90deg, rgba(241, 245, 249, 0.1) 0, rgba(241, 245, 249, 0.1) 1px, transparent 1px, transparent 80px);
  opacity: 0.3;
  filter: blur(0.5px);
  pointer-events: none;
  z-index: -3;
}

/* ============ ANIMATIONS ============ */
.reveal {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

/* Staggered Delays */
.delay-1 { transition-delay: 0.1s; }
.delay-2 { transition-delay: 0.2s; }
.delay-3 { transition-delay: 0.3s; }
.delay-4 { transition-delay: 0.4s; }
.delay-5 { transition-delay: 0.5s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

@keyframes shimmer {
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
}

/* ============ NAVIGATION ============ */
.navbar {
  background: rgba(2, 6, 23, 0.65);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.nav-link {
  color: var(--text-secondary);
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 1rem;
}

.nav-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -6px;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #cbd5e1, #f1f5f9);
  transition: width 0.3s ease;
}

.nav-link:hover {
  color: var(--text-primary);
}

.nav-link:hover::after {
  width: 100%;
}

/* ============ DIVIDERS ============ */
.divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  margin: 2rem 0;
}

/* ============ ICON CONTAINERS ============ */
.icon-container {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: rgba(226, 232, 240, 0.18);
  border: 1px solid rgba(226, 232, 240, 0.35);
  color: var(--primary-light);
  font-size: 1.5rem;
}

/* ============ RESPONSIVE DESIGN ============ */
@media (max-width: 992px) {
  :root {
    --section-padding: clamp(3rem, 6vw, 5rem);
  }
  
  .container {
    padding: 0 1.5rem;
  }
  
  .glass-panel {
    padding: 1.5rem;
  }
}

@media (max-width: 576px) {
  .glass-panel {
    padding: 1.25rem;
  }
  
  .card {
    padding: 1rem;
  }
  
  .grid-auto,
  .grid-stats,
  .grid-pills {
    grid-template-columns: 1fr;
  }
  
  .btn-primary,
  .btn-secondary {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
  }
}

/* ============ UTILITY CLASSES ============ */
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }

.mt-1 { margin-top: 0.5rem; }
.mt-2 { margin-top: 1rem; }
.mt-3 { margin-top: 1.5rem; }
.mt-4 { margin-top: 2rem; }

.mb-1 { margin-bottom: 0.5rem; }
.mb-2 { margin-bottom: 1rem; }
.mb-3 { margin-bottom: 1.5rem; }
.mb-4 { margin-bottom: 2rem; }

.gap-1 { gap: 0.5rem; }
.gap-2 { gap: 1rem; }
.gap-3 { gap: 1.5rem; }
.gap-4 { gap: 2rem; }

.flex { display: flex; }
.flex-col { flex-direction: column; }
.items-center { align-items: center; }
.justify-center { justify-content: center; }
.justify-between { justify-content: space-between; }

.w-full { width: 100%; }
.h-full { height: 100%; }

.relative { position: relative; }
.absolute { position: absolute; }

.overflow-hidden { overflow: hidden; }
.overflow-auto { overflow: auto; }

.pointer-events-none { pointer-events: none; }
.cursor-pointer { cursor: pointer; }

/* ============ LIGHT THEME SPECIFIC OVERRIDES ============ */
[data-theme="light"] .glass-panel {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(15, 23, 42, 0.1);
  box-shadow: 0 20px 80px rgba(15, 23, 42, 0.08);
}

[data-theme="light"] .card {
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
}

[data-theme="light"] .btn-primary {
  background: linear-gradient(120deg, #64748b, #475569);
  box-shadow: 0 20px 45px rgba(71, 85, 105, 0.3);
}

[data-theme="light"] .btn-primary:hover {
  box-shadow: 0 25px 55px rgba(71, 85, 105, 0.4);
}

[data-theme="light"] .btn-secondary {
  background: rgba(100, 116, 139, 0.08);
  border: 1px solid rgba(100, 116, 139, 0.2);
  color: #1e293b;
}

[data-theme="light"] .btn-secondary:hover {
  background: rgba(100, 116, 139, 0.12);
  border-color: rgba(100, 116, 139, 0.3);
}

[data-theme="light"] .eyebrow {
  background: rgba(100, 116, 139, 0.1);
  color: #475569;
}

[data-theme="light"] .icon-container {
  background: rgba(100, 116, 139, 0.1);
  border: 1px solid rgba(100, 116, 139, 0.2);
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-system.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,oDAAoD;AACpD,yBAAyB;AACzB;;EAEE,sCAAsC;EACtC,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;;EAEvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;;EAEjC,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,2CAA2C;EAC3C,oBAAoB;EACpB,qBAAqB;;EAErB,YAAY;EACZ,yCAAyC;EACzC,wCAAwC;;EAExC,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;;EAEvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,oCAAoC;;EAEpC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;;EAErB,YAAY;EACZ,qCAAqC;EACrC,wCAAwC;;EAExC,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0HAA0H;EAC1H,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA,oCAAoC;AACpC;EACE;;;;kBAIgB;EAChB,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE;;;;kBAIgB;EAChB,4BAA4B;AAC9B;;AAEA,yCAAyC;AACzC;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,qFAAqF;EACrF,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qDAAqD;EACrD,gDAAgD;EAChD,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,oCAAoC;AACpC;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,+CAA+C;EAC/C,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,8EAA8E;EAC9E,SAAS;EACT,WAAW;AACb;;AAEA;EACE,+EAA+E;EAC/E,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,+EAA+E;EAC/E,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;IACE,2CAA2C;IAC3C,aAAa;EACf;EACA;IACE,kDAAkD;IAClD,aAAa;EACf;AACF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,QAAQ;EACR;;;iIAG+H;EAC/H,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;;AAEnC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,KAAK,8BAA8B,EAAE;EACrC,OAAO,6BAA6B,EAAE;AACxC;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,WAAW;EACX,sFAAsF;EACtF,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,8CAA8C;AAC9C,eAAe,kBAAkB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,cAAc,iBAAiB,EAAE;;AAEjC,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;;AAE7B,SAAS,WAAW,EAAE;AACtB,SAAS,SAAS,EAAE;AACpB,SAAS,WAAW,EAAE;AACtB,SAAS,SAAS,EAAE;;AAEpB,QAAQ,aAAa,EAAE;AACvB,YAAY,sBAAsB,EAAE;AACpC,gBAAgB,mBAAmB,EAAE;AACrC,kBAAkB,uBAAuB,EAAE;AAC3C,mBAAmB,8BAA8B,EAAE;;AAEnD,UAAU,WAAW,EAAE;AACvB,UAAU,YAAY,EAAE;;AAExB,YAAY,kBAAkB,EAAE;AAChC,YAAY,kBAAkB,EAAE;;AAEhC,mBAAmB,gBAAgB,EAAE;AACrC,iBAAiB,cAAc,EAAE;;AAEjC,uBAAuB,oBAAoB,EAAE;AAC7C,kBAAkB,eAAe,EAAE;;AAEnC,6DAA6D;AAC7D;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB","sourcesContent":["/* ============================================\n   UNIVERSAL DESIGN SYSTEM - Glassmorphism Theme\n   ============================================ */\n\n/* ============ CSS CUSTOM PROPERTIES ============ */\n/* Dark Theme (Default) */\n:root,\n[data-theme=\"dark\"] {\n  /* Primary Colors - Light Gray Theme */\n  --primary-color: #cbd5e1;\n  --primary-dark: #94a3b8;\n  --primary-light: #e2e8f0;\n\n  /* Accent Colors - Very Light Grays */\n  --secondary-color: #e2e8f0;\n  --accent-color: #f1f5f9;\n\n  /* Backgrounds */\n  --dark-bg: #0f172a;\n  --light-bg: #f8fafc;\n  --body-bg: #0a1628;\n  --card-bg: rgba(15, 23, 42, 0.6);\n  --glass-bg: rgba(15, 23, 42, 0.7);\n\n  /* Text Colors */\n  --white: #ffffff;\n  --text-primary: rgba(241, 245, 249, 0.95);\n  --text-secondary: rgba(226, 232, 240, 0.75);\n  --text-dark: #1e293b;\n  --text-light: #64748b;\n\n  /* Borders */\n  --border-color: rgba(255, 255, 255, 0.08);\n  --border-hover: rgba(226, 232, 240, 0.4);\n\n  /* Spacing */\n  --section-padding: clamp(4rem, 8vw, 7rem);\n  --card-gap: 1.5rem;\n}\n\n/* Light Theme */\n[data-theme=\"light\"] {\n  /* Primary Colors */\n  --primary-color: #64748b;\n  --primary-dark: #475569;\n  --primary-light: #94a3b8;\n\n  /* Accent Colors */\n  --secondary-color: #94a3b8;\n  --accent-color: #cbd5e1;\n\n  /* Backgrounds */\n  --dark-bg: #0f172a;\n  --light-bg: #f8fafc;\n  --body-bg: #f1f5f9;\n  --card-bg: rgba(255, 255, 255, 0.9);\n  --glass-bg: rgba(255, 255, 255, 0.8);\n\n  /* Text Colors */\n  --white: #ffffff;\n  --text-primary: #1e293b;\n  --text-secondary: #475569;\n  --text-dark: #0f172a;\n  --text-light: #64748b;\n\n  /* Borders */\n  --border-color: rgba(15, 23, 42, 0.1);\n  --border-hover: rgba(100, 116, 139, 0.3);\n\n  /* Spacing */\n  --section-padding: clamp(4rem, 8vw, 7rem);\n  --card-gap: 1.5rem;\n}\n\n/* ============ GLOBAL RESETS & BASE STYLES ============ */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--body-bg);\n  color: var(--text-primary);\n  line-height: 1.8;\n  font-weight: 400;\n  min-height: 100vh;\n  overflow-x: hidden;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Dark theme background gradients */\n[data-theme=\"dark\"] body {\n  background:\n    radial-gradient(circle at 10% 20%, rgba(226, 232, 240, 0.15), transparent 50%),\n    radial-gradient(circle at 90% 10%, rgba(241, 245, 249, 0.12), transparent 45%),\n    radial-gradient(circle at 50% 80%, rgba(203, 213, 225, 0.1), transparent 50%),\n    var(--body-bg);\n  background-attachment: fixed;\n}\n\n/* Light theme background gradients */\n[data-theme=\"light\"] body {\n  background:\n    radial-gradient(circle at 10% 20%, rgba(100, 116, 139, 0.08), transparent 50%),\n    radial-gradient(circle at 90% 10%, rgba(148, 163, 184, 0.06), transparent 45%),\n    radial-gradient(circle at 50% 80%, rgba(203, 213, 225, 0.05), transparent 50%),\n    var(--body-bg);\n  background-attachment: fixed;\n}\n\n/* ============ TYPOGRAPHY ============ */\nh1 {\n  font-size: clamp(2.5rem, 5vw, 4rem);\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--text-primary);\n  margin-bottom: 1rem;\n}\n\n[data-theme=\"dark\"] h1 {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"light\"] h1 {\n  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\nh2 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 1rem;\n}\n\nh3 {\n  font-size: clamp(1.5rem, 3vw, 2rem);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.75rem;\n}\n\nh4 {\n  font-size: clamp(1.25rem, 2.5vw, 1.75rem);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n}\n\np {\n  color: var(--text-secondary);\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\na {\n  color: var(--primary-light);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\na:hover {\n  color: var(--primary-color);\n}\n\n/* ============ LAYOUT PATTERNS ============ */\n.section {\n  position: relative;\n  padding: var(--section-padding) 0;\n  isolation: isolate;\n}\n\n.section::after {\n  content: '';\n  position: absolute;\n  inset: 1rem;\n  border-radius: 32px;\n  background: radial-gradient(circle at top, rgba(226, 232, 240, 0.1), transparent 55%);\n  z-index: -2;\n  pointer-events: none;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* ============ GLASSMORPHISM COMPONENTS ============ */\n.glass-panel {\n  border-radius: 24px;\n  padding: 2rem;\n  background: var(--glass-bg);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 20px 80px rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  transition: all 0.45s ease;\n}\n\n.glass-panel:hover {\n  border-color: rgba(226, 232, 240, 0.4);\n  transform: translateY(-4px);\n}\n\n.card {\n  padding: 1.5rem;\n  border-radius: 22px;\n  border: 1px solid var(--border-color);\n  background: var(--card-bg);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  transition: transform 0.45s ease, border-color 0.45s ease, box-shadow 0.45s ease;\n}\n\n.card:hover {\n  transform: translateY(-6px);\n  border-color: rgba(226, 232, 240, 0.5);\n  box-shadow: 0 20px 60px rgba(203, 213, 225, 0.2);\n}\n\n/* ============ PILLS & CHIPS ============ */\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  border-radius: 999px;\n  padding: 0.35rem 1rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  background: var(--card-bg);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n}\n\n.pill:hover {\n  background: rgba(226, 232, 240, 0.15);\n  border-color: rgba(226, 232, 240, 0.35);\n}\n\n/* ============ EYEBROW LABELS ============ */\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.2rem;\n  font-size: 0.75rem;\n  color: var(--primary-light);\n  background: rgba(226, 232, 240, 0.12);\n  padding: 0.35rem 0.9rem;\n  border-radius: 999px;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n/* ============ BUTTONS ============ */\n.btn-primary {\n  border-radius: 999px;\n  padding: 0.85rem 1.8rem;\n  border: none;\n  font-weight: 600;\n  background: linear-gradient(120deg, #cbd5e1, #94a3b8);\n  box-shadow: 0 20px 45px rgba(148, 163, 184, 0.3);\n  color: #fff;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 25px 55px rgba(203, 213, 225, 0.4);\n}\n\n.btn-secondary {\n  border-radius: 999px;\n  padding: 0.85rem 1.8rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--white);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--primary-light);\n}\n\n/* ============ STAT CARDS ============ */\n.stat-card {\n  padding: 1.35rem;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(226, 232, 240, 0.4);\n}\n\n.stat-card strong {\n  display: block;\n  font-size: 1.8rem;\n  color: var(--text-primary);\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n}\n\n.stat-card span {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n/* ============ GRID SYSTEMS ============ */\n.grid {\n  display: grid;\n  gap: var(--card-gap);\n}\n\n.grid-auto {\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n}\n\n.grid-stats {\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n\n.grid-pills {\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n/* ============ FORMS ============ */\n.form-control {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  border-radius: 12px;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.form-control:focus {\n  border-color: var(--primary-light);\n  box-shadow: 0 0 0 3px var(--border-hover);\n  outline: none;\n  background: var(--glass-bg);\n}\n\n.form-control::placeholder {\n  color: var(--text-light);\n  opacity: 0.6;\n}\n\n.form-label {\n  color: var(--text-primary);\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  display: block;\n}\n\n/* ============ ATMOSPHERIC EFFECTS ============ */\n.aurora {\n  position: absolute;\n  width: min(45vw, 520px);\n  height: min(45vw, 520px);\n  border-radius: 55%;\n  filter: blur(120px);\n  opacity: 0.35;\n  mix-blend-mode: screen;\n  animation: auroraPulse 22s ease-in-out infinite;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.aurora-pink {\n  background: radial-gradient(circle, rgba(241, 245, 249, 0.3), transparent 65%);\n  top: -10%;\n  right: -10%;\n}\n\n.aurora-blue {\n  background: radial-gradient(circle, rgba(226, 232, 240, 0.28), transparent 65%);\n  bottom: -10%;\n  left: -10%;\n  animation-delay: -11s;\n}\n\n.aurora-cyan {\n  background: radial-gradient(circle, rgba(248, 250, 252, 0.25), transparent 65%);\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation-delay: -5s;\n}\n\n@keyframes auroraPulse {\n  0%, 100% {\n    transform: scale(0.85) translate3d(0, 0, 0);\n    opacity: 0.25;\n  }\n  50% {\n    transform: scale(1.05) translate3d(-10px, 10px, 0);\n    opacity: 0.45;\n  }\n}\n\n/* ============ GRID OVERLAY PATTERN ============ */\n.grid-overlay {\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(135deg, rgba(226, 232, 240, 0.12), transparent),\n    repeating-linear-gradient(0deg, rgba(241, 245, 249, 0.1) 0, rgba(241, 245, 249, 0.1) 1px, transparent 1px, transparent 80px),\n    repeating-linear-gradient(90deg, rgba(241, 245, 249, 0.1) 0, rgba(241, 245, 249, 0.1) 1px, transparent 1px, transparent 80px);\n  opacity: 0.3;\n  filter: blur(0.5px);\n  pointer-events: none;\n  z-index: -3;\n}\n\n/* ============ ANIMATIONS ============ */\n.reveal {\n  opacity: 0;\n  transform: translateY(30px);\n  transition: all 0.8s ease-out;\n}\n\n.reveal.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Staggered Delays */\n.delay-1 { transition-delay: 0.1s; }\n.delay-2 { transition-delay: 0.2s; }\n.delay-3 { transition-delay: 0.3s; }\n.delay-4 { transition-delay: 0.4s; }\n.delay-5 { transition-delay: 0.5s; }\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-20px); }\n}\n\n@keyframes shimmer {\n  0% { background-position: -1000px 0; }\n  100% { background-position: 1000px 0; }\n}\n\n/* ============ NAVIGATION ============ */\n.navbar {\n  background: rgba(2, 6, 23, 0.65);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.nav-link {\n  color: var(--text-secondary);\n  font-weight: 500;\n  transition: all 0.3s ease;\n  position: relative;\n  padding: 0.5rem 1rem;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -6px;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #cbd5e1, #f1f5f9);\n  transition: width 0.3s ease;\n}\n\n.nav-link:hover {\n  color: var(--text-primary);\n}\n\n.nav-link:hover::after {\n  width: 100%;\n}\n\n/* ============ DIVIDERS ============ */\n.divider {\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  margin: 2rem 0;\n}\n\n/* ============ ICON CONTAINERS ============ */\n.icon-container {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background: rgba(226, 232, 240, 0.18);\n  border: 1px solid rgba(226, 232, 240, 0.35);\n  color: var(--primary-light);\n  font-size: 1.5rem;\n}\n\n/* ============ RESPONSIVE DESIGN ============ */\n@media (max-width: 992px) {\n  :root {\n    --section-padding: clamp(3rem, 6vw, 5rem);\n  }\n  \n  .container {\n    padding: 0 1.5rem;\n  }\n  \n  .glass-panel {\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .glass-panel {\n    padding: 1.25rem;\n  }\n  \n  .card {\n    padding: 1rem;\n  }\n  \n  .grid-auto,\n  .grid-stats,\n  .grid-pills {\n    grid-template-columns: 1fr;\n  }\n  \n  .btn-primary,\n  .btn-secondary {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.95rem;\n  }\n}\n\n/* ============ UTILITY CLASSES ============ */\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.mt-1 { margin-top: 0.5rem; }\n.mt-2 { margin-top: 1rem; }\n.mt-3 { margin-top: 1.5rem; }\n.mt-4 { margin-top: 2rem; }\n\n.mb-1 { margin-bottom: 0.5rem; }\n.mb-2 { margin-bottom: 1rem; }\n.mb-3 { margin-bottom: 1.5rem; }\n.mb-4 { margin-bottom: 2rem; }\n\n.gap-1 { gap: 0.5rem; }\n.gap-2 { gap: 1rem; }\n.gap-3 { gap: 1.5rem; }\n.gap-4 { gap: 2rem; }\n\n.flex { display: flex; }\n.flex-col { flex-direction: column; }\n.items-center { align-items: center; }\n.justify-center { justify-content: center; }\n.justify-between { justify-content: space-between; }\n\n.w-full { width: 100%; }\n.h-full { height: 100%; }\n\n.relative { position: relative; }\n.absolute { position: absolute; }\n\n.overflow-hidden { overflow: hidden; }\n.overflow-auto { overflow: auto; }\n\n.pointer-events-none { pointer-events: none; }\n.cursor-pointer { cursor: pointer; }\n\n/* ============ LIGHT THEME SPECIFIC OVERRIDES ============ */\n[data-theme=\"light\"] .glass-panel {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  box-shadow: 0 20px 80px rgba(15, 23, 42, 0.08);\n}\n\n[data-theme=\"light\"] .card {\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);\n}\n\n[data-theme=\"light\"] .btn-primary {\n  background: linear-gradient(120deg, #64748b, #475569);\n  box-shadow: 0 20px 45px rgba(71, 85, 105, 0.3);\n}\n\n[data-theme=\"light\"] .btn-primary:hover {\n  box-shadow: 0 25px 55px rgba(71, 85, 105, 0.4);\n}\n\n[data-theme=\"light\"] .btn-secondary {\n  background: rgba(100, 116, 139, 0.08);\n  border: 1px solid rgba(100, 116, 139, 0.2);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .btn-secondary:hover {\n  background: rgba(100, 116, 139, 0.12);\n  border-color: rgba(100, 116, 139, 0.3);\n}\n\n[data-theme=\"light\"] .eyebrow {\n  background: rgba(100, 116, 139, 0.1);\n  color: #475569;\n}\n\n[data-theme=\"light\"] .icon-container {\n  background: rgba(100, 116, 139, 0.1);\n  border: 1px solid rgba(100, 116, 139, 0.2);\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
